import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getStatus, multiProductStatus } from "utils/utils";
import { useTranslations } from "hooks/UseTranslations";
import DatagridMobileView from "components/DataGridMobileView/DataGridMobileVeiw";
import Acordion from "components/Acordion/Acordion";
import dayjs from "dayjs";
import styles from "components/DataGridMobileView/DataGridMobileView.module.scss";

export default function MobileView({ allOrders, filteredData, pageSize, emptyStateMsg }) {
    const navigate = useNavigate();
    const [showLoadMore, setShowLoadMore] = useState(true);
    const [filteredList, setFilteredList] = useState([]);
    const { translations } = useTranslations();
    const products = (items: []) => {
        let updateItems = [...items];
        updateItems.shift();
        return (
            <div className={styles.accordion}>
                {updateItems.map((el, i) => (
                    <p key={i}>{el}</p>
                ))}
            </div>
        );
    };

    useEffect(() => {
        let slicedFilteredData = [...filteredData.slice(0, pageSize)];
        setFilteredList(slicedFilteredData);
        setShowLoadMore(filteredData.length > pageSize);
    }, [filteredData, pageSize]);

    const handleLoadMore = () => {
        setFilteredList(filteredData);
        setShowLoadMore(false);
    };

    const leftCells = [
        {
            renderCell: (params: any) => (
                <div className={`${styles.mainText} ${styles.bold}`}>{params.ta_id + "/" + params.transaction_id}</div>
            )
        },
        {
            renderCell: (params) => {
                if (params.items.length > 1) {
                    return (
                        <>
                            <Acordion
                                style={{ boxShadow: "none !important" }}
                                rmTitlePadding
                                styleTitle={{ fontSize: "14px", color: "#000000" }}
                                title={params.product_name}
                                description={products(params.items)}
                            />
                            <div className={styles.secondaryText}>{`${dayjs(params.booking_date).format(
                                "DD.MM.YYYY"
                            )} `}</div>
                        </>
                    );
                }
                return <p className={styles.mainText}>{params.product_name}</p>;
            }
        },
        {
            renderCell: (params: any) => (
                <>
                    <div className={styles.mainText}>{params.merchant_name}</div>
                    {/* <div className={styles.mainText}>{params.type_of_test}</div> */}
                </>
            )
        }
    ];

    const rightCells = [
        {
            renderCell: (params: any) => {
                let status_record_states = allOrders
                    .filter((el) => el.product_order_id === params.product_order_id)
                    .map((el) => el.item_record_state);

                const status =
                    status_record_states.length > 1
                        ? multiProductStatus(status_record_states)
                        : getStatus(params.record_state);

                let color;
                switch (status) {
                    case "status.closed":
                        color = "#454545";
                        break;
                    case "status.open":
                        color = "#20C073";
                        break;
                    case "status.canceled":
                        color = "#E42011";
                        break;
                    default:
                        color = "white";
                        break;
                }

                return (
                    <div className={`${styles.totalContent} `}>
                        <span style={{ marginTop: 1 }}>{`€ ${params.amount.toFixed(2)} `}</span>
                        <span style={{ color: color }}>{" • " + translations(status)}</span>
                    </div>
                );
            }
        },
        {
            renderCell: (params: any) => {
                return (
                    <button
                        className={styles.btnViewMore}
                        onClick={() => navigate(`/web/my-orders/view-order/${params.product_order_id}`)}>
                        {translations("button.view_order")}
                    </button>
                );
            }
        }
    ];

    return (
        <>
            {filteredList.length > 0 ? (
                filteredList.map((el, idx) => (
                    <DatagridMobileView
                        key={idx}
                        headerColumns={["ID", translations("label.total")]}
                        data={el}
                        leftCells={leftCells}
                        rightCells={rightCells}
                    />
                ))
            ) : (
                <p className={styles.emptyStateText}>{emptyStateMsg}</p>
            )}
            {showLoadMore && (
                <div
                    className={`loadMoreCard`}
                    style={{ margin: "auto", marginBottom: "10px" }}
                    onClick={() => handleLoadMore()}>
                    <span>{translations("action.see_more")}</span>
                </div>
            )}
        </>
    );
}
